<template>
  <div class="background" :style="'background-image: url(' + Background + ')'">
    <CollectibleMobile
      v-if="isMobile"
      :collectible="collectible"
      :token="token"
      :listing="listing"
      @cancelListing="cancelListing()"
      @listingComplete="listingComplete()"
      @orderComplete="orderComplete()"
    />
    <CollectibleDesktop
      v-else
      :collectible="collectible"
      :token="token"
      :listing="listing"
      @cancelListing="cancelListing()"
      @listingComplete="listingComplete()"
      @orderComplete="orderComplete()"
    />
  </div>
</template>

<script>
  import Background from '@/assets/Background.png';
  import { mapState, mapActions } from 'vuex';
  import CollectiblesController from '@/controllers/CollectiblesController';
  import MarketplaceController from '@/controllers/MarketplaceController';

  export default {
    name: 'Collectibles',

    components: {
      CollectibleDesktop: () => import('./CollectibleDesktop.vue'),
      CollectibleMobile: () => import('./CollectibleMobile.vue'),
    },

    props: ['isMobile'],

    data: () => ({
      Background,
      collectible: null,
      token: null,
      listing: null,
    }),

    computed: {
      ...mapState({
        user: (state) => state.user.user,
      }),
      collectibleId() {
        return this.$route.params.collectibleId;
      },
      tokenId() {
        return this.$route.params.tokenId;
      },
    },

    watch: {
      $route() {
        this.getToken();
      },
    },

    mounted() {
      this.getToken();
    },

    methods: {
      ...mapActions({ setUser: 'setUser', setTokens: 'setTokens' }),
      getTokens: async function() {
        const tokens = await CollectiblesController.getTokens();
        this.setTokens(tokens);
      },
      getToken: async function() {
        try {
          const {
            collectible,
            token,
            listing,
          } = await CollectiblesController.getToken(
            this.collectibleId,
            this.tokenId
          );
          this.collectible = collectible;
          this.token = token;
          this.listing = listing;
        } catch (err) {
          this.$emit('handleError', err);
        }
      },
      cancelListing: async function() {
        try {
          await MarketplaceController.cancelListing(this.listing);
          this.listing = null;
          await this.getTokens();
        } catch (err) {
          this.$emit('handleError', err);
        }
      },
      async orderComplete() {
        await this.getToken();
        this.$emit('refreshUser');
      },
      async listingComplete() {
        await this.getToken();
        await this.getTokens();
        this.$emit('refreshUser');
      },
    },
  };
</script>

<style scoped>
  .background {
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>
